module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "page-heading"
  }, [_vm._v("\n    Roundupper\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c654f072"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 229
// module chunks = 0